import React from 'react';
import { ClipboardListIcon, FileTextIcon, MicroscopeIcon, RulerIcon, UsersIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { CTAButton } from '../ui/CTAButton';
import { resources } from '../../data/offer';
const icons = [MicroscopeIcon, ClipboardListIcon, RulerIcon, FileTextIcon, UsersIcon];
export function Resources() {
  return <section className="w-full bg-white px-4 py-16 md:py-24" data-id="element-252" data-mp="1izov6pz5rtxa">
      <div className="mx-auto max-w-4xl" data-id="element-253" data-mp="1ixvo59kmv7or">
        <SectionHeader kicker="More than six educational volumes" title="Practical Resources to Complement Your Hair Transplant Blueprint" intro={['The collection also brings together practical educational materials designed to support organized study and documentation.']} data-id="element-254" data-mp="1eyd1a8994mja" />

        <ul className="mt-12 divide-y divide-line border-y border-line" data-id="element-255" data-mp="22mwbwufrxbej">
          {resources.map((resource, i) => {
          const Icon = icons[i];
          return <li key={resource.title} className="flex items-start gap-4 py-6" data-id="element-256" data-mp="1ajjhmcmeesvt" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy text-cyan" data-id="element-257" data-mp="1almgzn9fxyd7">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-258" data-mp="1jk7w18fpev98" />
                </span>
                <div data-id="element-259" data-mp="1jmat2cf9xong">
                  <h3 className="font-display text-lg font-black uppercase leading-tight text-heading" data-id="element-260" data-mp="1ojkihs2ny0ba">{resource.title}</h3>
                  <p className="mt-1.5 text-[16px] leading-relaxed text-body" data-id="element-261" data-mp="1th2qng8uwbi8">{resource.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[16px] font-medium text-body" data-id="element-262" data-mp="237fcrcwbkcqh">
          These resources complement the six volumes and help create a more cohesive educational reference library.
        </p>

        <div className="mt-10" data-id="element-263" data-mp="2c9okjv07ds06">
          <CTAButton label="Get the complete Hair Transplant Blueprint™" sub="One-time payment · $27 USD" tone="light" data-id="element-264" data-mp="2c6ivgfrkqq4g" />
        </div>
      </div>
    </section>;
}